import { Component, OnInit,Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { MifielSignatureService } from 'src/app/services/mifiel-signature.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { CommonModule } from '@angular/common';
import { LocalDataSource } from 'ng2-smart-table';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-hook-archive',
  templateUrl: './hook-archive.component.html',
  styleUrls: ['./hook-archive.component.css']
})
export class HookArchiveComponent implements OnInit    {
  fileInfos?: Observable<any>;
  private scriptParentNode?: Node;
  mifiel_url = environment.mifiel_url;
  loading: boolean = false;

  constructor(private errorHandler: ErrorHandlerService,
    private miFielSignatureService: MifielSignatureService,
    private router: Router){  }

    // settings: Settings = {
    //   columns: {
    //     id: {
    //       title: 'ID'
    //     },
    //     name: {
    //       title: 'Full Name'
    //     },
    //     username: {
    //       title: 'User Name'
    //     },
    //     email: {
    //       title: 'Email'
    //     }
    //   }
    // };

  // ngOnInit(): void {
  //   // console.log("call load")
  //   this.loadCount(localStorage.getItem('userTaxId'));
  //   this.fileInfos = this.miFielSignatureService.getDocumentsByUserTaxId(localStorage.getItem('userTaxId'));

  //   console.log('fileInfos');
  //   console.log(this.fileInfos);

  // }

  ngOnInit(): void {
    this.loadCount(localStorage.getItem('userTaxId'));
  
    this.fileInfos = this.miFielSignatureService.getDocumentsByUserTaxId(localStorage.getItem('userTaxId')).pipe(
      map((files: any[]) =>
        files.map((file) => ({
          ...file,
          loading: false, // Add the loading property
        }))
      )
    );
  
    console.log('fileInfos as Observable:', this.fileInfos);
  }
  


  loadCount(userTaxId: string): void {
    // Example of using an HTTP service that might fail
    this.miFielSignatureService.getCountByUserTaxId(userTaxId).subscribe({
      next: (data) => {
        console.log('Server Says...');
        console.log(data['thisMonthSignatures'])
      },
      error: (error) => {
        this.errorHandler.checkForError(error,'file-upload -> loadCount');
      }
    });
  }  

  // openPreview(idRef: any): void {
  //   console.log("openPreview: ",idRef);
  //   // console.log("idRef", idRef.hook_id)
  //   // this.fileInfos= this.miFielSignatureService.previewDocument(idRef);
  //   this.miFielSignatureService.previewDocument(idRef).subscribe((blob) => {
  //     const url = window.URL.createObjectURL(blob);
  //     window.open(url);
  //   });
  // }

  // openPreview(idRef: any): void {
  //   console.log("openPreview: ", idRef);
  //   this.miFielSignatureService.previewDocument(idRef).subscribe({
  //     next: (blob) => {
  //       const url = window.URL.createObjectURL(blob);
  //       window.open(url);
  //     },
  //     error: (err) => {
  //       console.error("Error previewing document:", err);
  //       // Navigate to an error page or show an error message
  //       // Option 1: If you have a dedicated error page
  //       this.router.navigate(['/error-page']); // Replace with the actual route for your error page
  //       // Option 2: Display an error message directly
  //       // this.errorMessage = "An error occurred while loading the document.";
  //     }
  //   });
  // }
  
  // hook-archive.component.ts
  openPreview(idRef: any): void {
    console.log("openPreview:" + idRef)
    this.miFielSignatureService.previewDocument(idRef).subscribe({
      next: (blob) => {
        console.log("openPreview -> next");
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      error: (err) => {
        console.error("Error previewing document:", err);
        // Navigate to the error page
        this.router.navigate(['/error-page']); // Ensure your error page route is correct
      }
    });
  }

  openPreview3(file: any): void {
    // Set loading state for this file
    file.loading = true;
  
    this.miFielSignatureService.previewDocument(file.hook_id).subscribe({
      next: (blob) => {
        console.log("openPreview -> next");
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      error: (err) => {
        console.error("Error previewing document:", err);
        // Navigate to the error page
        this.router.navigate(['/error-page']); // Ensure your error page route is correct
      },
      complete: () => {
        // Reset loading state
        file.loading = false;
      },
    });
  }


}
